// API 基地址统一配置
// 可通过 Vite 环境变量覆盖，默认值保持现有配置

export const DATA_SERVER_BASE =
  import.meta.env.VITE_DATA_SERVER || '';

export const DATA_SERVER_PATH = '/ktsy/nanjing/addp';

export const FASTGPT_BASE =
  import.meta.env.VITE_FASTGPT_URL || '';

export const TILE_BASE =
  import.meta.env.VITE_TILE_BASE || 'https://www.daditu.com.cn';

export const GEOCODER_URL =
  import.meta.env.VITE_GEOCODER_URL || 'https://www.daditu.com.cn';

// 拼接数据服务器完整 URL
export const dataServerUrl = (endpoint: string, params?: Record<string, string | number>) => {
  const basePath = `${DATA_SERVER_PATH}/${endpoint}`;
  const queryStr = params ? '?' + new URLSearchParams(
    Object.fromEntries(Object.entries(params).map(([k, v]) => [k, String(v)]))
  ).toString() : '';
  if (DATA_SERVER_BASE) {
    return `${DATA_SERVER_BASE}${basePath}${queryStr}`;
  }
  // 空 base → 同域请求（通过 Nginx 代理）
  return `${basePath}${queryStr}`;
};
